__webpack_require__.p = "https://rama.sementenegocios.com.br/app/";